export function setFocus(id: string, delay = 0, setInput = false): void {
  const doFocus = () => {
    const el = document.getElementById(id);
    if (!el) return;
    el.focus();
    if (setInput && el instanceof HTMLInputElement) {
      setTimeout(() => {
        const len = el.value.length;
        el.setSelectionRange(len, len);
      }, 100);
    }
  };
  if (delay > 0) {
    setTimeout(doFocus, delay);
  } else {
    doFocus();
  }
}
